<template>
  <div>
    <div class="container">
      <el-row>
        <el-col :span="8">
           <span class="label">合同编号:</span>{{info.contractNumber}}
        </el-col>
        <el-col :span="8">
          <span class="label">电量偏差率(%)：</span>{{info.powerDeviationRate}}
        </el-col>
        <el-col :span="8">
          <span class="label">联系人：</span>{{info.contacts}}
        </el-col>
        <el-col :span="8">
          <span class="label">合同名称：</span>{{info.contractName}}
        </el-col>
        <el-col :span="8">
          <span class="label">偏差罚款承担比例：</span>{{info.penaltyRate}}
        </el-col>
        <el-col :span="8">
          <span class="label">联系电话：</span>{{info.contactsNumber}}
        </el-col>
        <el-col :span="8">
          <span class="label">区域：</span>{{info.cityName}}
        </el-col>
        <el-col :span="8">
          <span class="label">客户售电套餐：</span>{{info.elePackage}}
        </el-col>
        <el-col :span="8">
          <span class="label">合同状态：</span>{{info.businessNature==0?'未执行':'已执行'}}
        </el-col>
        <el-col :span="8">
          <span class="label">所属企业：</span>{{info.enterprise}}
        </el-col>
        <el-col :span="8">
          <span class="label">自定义售电套餐：</span>{{info.customElePackage}}
        </el-col>
        <el-col :span="8">
          <span class="label">绑定状态：</span>{{info.bindingStatus==0?'未绑定':'已绑定'}}
        </el-col>
        <el-col :span="8">
          <span class="label">签约时间：</span>{{info.signDate}}
        </el-col>
        <el-col :span="8">
          <span class="label">现货市场:</span>{{info.spotMarket}}
        </el-col>

        <el-col :span="8">
          <span class="label">绑定日期：</span>{{info.bindingDate}}
        </el-col>

        <el-col :span="8">
          <span class="label">合同截至时间：</span>{{info.endDate}}
        </el-col>

        <el-col :span="8">
          <span class="label">需求侧响应：</span>{{info.demandRes==0?'未响应':'已响应'}}
        </el-col>
        <el-col :span="8">
          <span class="label">失效日期：</span>{{info.expireDate}}
        </el-col>
        <el-col :span="8">
<span class="label">签约年限:</span>{{info.terms}}
        </el-col>
        <el-col :span="8">
          <span class="label">能源管理服务：</span>{{info.manageServices}}
        </el-col>
        <el-col :span="8">
          <span class="label">成交状态：</span>{{info.transactionStatus==0?'未成交':'已成交'}}
        </el-col>
        <el-col :span="8">
          <span class="label">合同电量(kW·h)：</span>{{info.contractCapacity}}
        </el-col>
        <el-col :span="8">
          <span class="label">分成比例：</span>{{info.shareRatio}}
        </el-col>
        <el-col :span="8">

        </el-col>
        <el-col :span="8">
          <span class="label">签约价格(尖)(元/千瓦时)：</span>{{info.contractJianPrice}}
        </el-col>
                <el-col :span="8">
          <span class="label">签约价格(峰)(元/千瓦时)：</span>{{info.contractFengPrice}}
        </el-col>
                <el-col :span="8">
          <span class="label">签约价格(平)(元/千瓦时)：</span>{{info.contractPingPrice}}
        </el-col>
                <el-col :span="8">
          <span class="label">签约价格(谷)(元/千瓦时)：</span>{{info.contractGuPrice}}
        </el-col>
        <el-col :span="8">
          <span class="label">违约信息备注：</span>{{info.breachRemarks}}
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { getcontractOne } from '../../API'
export default {
  data(){
    return{
      info:{},
            tableData:[
        {name:1}
      ]
    }
  },
    created(){
    getcontractOne(localStorage.getItem('contractId')).then(res=>{
      if(res.code===0){
        this.info=res.data
        console.log(this.info)
      }
    })
  }
}
</script>

<style lang='less' scoped>
.container {
  padding: 10px;
  border: none;
}
.text {
  font-weight: 650;
  font-style: normal;
  font-size: 14px;
  color: #666666;
  line-height: 21px;
}
.ax_default {
  font-family: "ArialMT", "Arial";
  font-weight: 400;
  font-style: normal;
  font-size: 13px;
  border-bottom: 1px solid rgb(228, 228, 228);
  text-align: center;
  line-height: normal;
}
.line {
  height: 1px;
}
.el-col {
  height: 40px;
  align-content: center;
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #666666;
}
</style>